/* eslint-disable import/no-anonymous-default-export */
export default (currentPrice = [], action) => {
  switch (action.type) {
    case "GET_CURRENT_PRICES":
      return action.payload;

    default:
      return currentPrice;
  }
};
